const popoverOverflowModifiers = {
  preventOverflow: { boundariesElement: "viewport" },
  hide: {
    enabled: false
  },
  flip: {
    boundariesElement: "viewport"
  }
};
export default popoverOverflowModifiers;
